/**
 * 새 악보 화면 미리 써보기 (2026-10). 주소 끝에 ?beta=1 을 붙여 한 번 들어오면 그 기기에서만 켜지고,
 * ?beta=0 으로 끈다. 사장님 계정은 로그인만 하면 자동으로 켜진다 (?beta=0 으로 끄면 그 기기에서는 꺼진 채 유지).
 * 2026-10-04 사장님 지시로 전체 공개: ALL_ON 이면 모든 회원이 새 화면 (?beta=0 으로 끈 기기만 예전 화면).
 * 문제가 생기면 ALL_ON 을 false 로 바꿔 다시 배포하면 예전처럼 미리 써보기 계정만.
 */
const ALL_ON = true;
const KEY = 'scoreBeta';
const OPT_OUT = 'scoreBetaOff';
const BETA_USER_IDS = [21350]; // 사장님 계정

export const syncBetaFromUrl = () => {
  try {
    const v = new URLSearchParams(window.location.search).get('beta');
    if (v === '1') {
      localStorage.setItem(KEY, '1');
      localStorage.removeItem(OPT_OUT);
    }
    if (v === '0') {
      localStorage.removeItem(KEY);
      localStorage.setItem(OPT_OUT, '1');
    }
  } catch (e) {}
};

/** /api/user 응답을 받은 뒤 호출: 미리 써보기 계정이면 켠다 */
export const applyBetaForUser = (userId?: number) => {
  try {
    if (userId && BETA_USER_IDS.includes(Number(userId)) && localStorage.getItem(OPT_OUT) !== '1') {
      localStorage.setItem(KEY, '1');
    }
  } catch (e) {}
};

export const isScoreBeta = () => {
  try {
    if (localStorage.getItem(OPT_OUT) === '1') return false;
    return ALL_ON || localStorage.getItem(KEY) === '1';
  } catch (e) {
    return ALL_ON;
  }
};
